// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e8fc6fba","703":"86357b8a","787":"4d76f5fd"}[chunkId] + ".chunk.js";
};